import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';

// import BotAvatar from '../BotAvatar';

const MessageContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: flex-end;
  margin-bottom: 2px;
`;

const Grow = styled.div`
  flex-grow: 1;
`;

// Create the wave animation keyframes
const bounce = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
`;

const IndicatorWrapper = styled.div`
  background-color: transparent;
  flex-grow: 0;
  width: 55px;
  height: 35px;
  display: flex;
  justify-content: space-around;
  align-items: end;
  padding: 0 5px;
  margin-left: 15px;
  box-sizing: border-box;
`;

const Dot = styled.div`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: #999;
  animation: ${bounce} 1.2s infinite ease-in-out;
  animation-delay: ${props => props.delay}s;
`;

class TypingIndicator extends Component {
  render() {
    return (
      <MessageContainer>
        {/* <BotAvatar
          visible={this.props.from === 'Bot'}
          inOperatorConversation={this.props.inOperatorConversation}
        /> */}
        <IndicatorWrapper>
          <Dot delay={0} />
          <Dot delay={0.2} />
          <Dot delay={0.4} />
        </IndicatorWrapper>
        <Grow />
      </MessageContainer>
    );
  }
}

export default TypingIndicator;



// WEBPACK FOOTER //
// ./src/components/MessageHistory/TypingIndicator/index.js